













import Vue, { PropType } from 'vue'
import XIcon, { IconProps } from '@/components/atoms/Icon/XIcon.vue'
import XCard from '@/components/atoms/Card/XCard.vue'

export type AccountItemProps = {
  icon: IconProps
  title: string
  routeName: string
}

export default Vue.extend<{}, {}, {}, AccountItemProps>({
  name: 'AccountItem',
  components: { XIcon, XCard },
  props: {
    icon: {
      type: Object as PropType<IconProps>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    routeName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    handleClick() {
      this.$router.push({ name: this.routeName })
    },
  },
})
